import { isoOptions } from './iso'
import { queueOptions } from './queue'
import { developers, utilities, other, ipp } from './favicons'

// This is the dashboard EntitySelect list
export const entityLists = {
  //regions: mappedRegionOptions,
  iso: isoOptions,
  queue: queueOptions,
}

const icons = [...developers, ...utilities, ...other, ...ipp]
export const favicons = new Map(icons.map((obj) => [obj.key, obj.value]))
